import { FC } from 'react';
import { useIntl } from 'react-intl';
import { Select } from 'components/common/Select';
import { TextField } from 'components/common/TextField';
import { IProductSelectOption } from 'pages/CalculatorPage/types';
import { FormattedCalculatorResult } from '../types';
import { ResultsSectionQuestions } from './questions';
import { ResultsSectionProps, ResultsSortingTypesEnum } from './types';
import { ResultItem } from '../ResultItem';
import { SelectedResultItem } from '../SelectedResultItem';

export const ResultsSection: FC<ResultsSectionProps> = ({
  bestProduct,
  productOptions,
  financeDetails,
  setSortBy,
  sortBy,
}) => {
  const intl = useIntl();
  const { sort } = ResultsSectionQuestions(intl);

  const getSortingFunction = (sortBy: string) => {
    switch (sortBy) {
      case ResultsSortingTypesEnum.initialMonthlyRepaymentsAsc:
        return (a: FormattedCalculatorResult, b: FormattedCalculatorResult) => a.repayments - b.repayments;
      case ResultsSortingTypesEnum.initialRateAsc:
        return (a: FormattedCalculatorResult, b: FormattedCalculatorResult) => a.initialRate - b.initialRate;
      case ResultsSortingTypesEnum.initialTermAsc:
        return (a: FormattedCalculatorResult, b: FormattedCalculatorResult) => a.term - b.term;
      case ResultsSortingTypesEnum.maxFinancingDesc:
        return (a: FormattedCalculatorResult, b: FormattedCalculatorResult) => b.maxFinancing - a.maxFinancing;
      default:
        return () => 0;
    }
  };

  const sortingFunction = getSortingFunction(sortBy);

  return (
    <div className={'xs:my-8 md:my-10'}>
      {bestProduct && <SelectedResultItem resultItem={bestProduct} financeDetails={financeDetails} />}
      <div className={'ml-auto flex w-1/2'}>
        {productOptions.length ? (
          <>
            <p className={'text-main whitespace-nowrap font-black'}>Sort by</p>
            <Select
              disableClearable
              className={'ml-4 w-full'}
              options={sort.options}
              value={sort.options.find(option => option.value === sortBy) || null}
              renderInput={({ inputProps, ...params }: any) => (
                <TextField
                  {...params}
                  placeholder={intl.formatMessage({ id: 'placeholders.select' })}
                  inputProps={{ ...inputProps, readOnly: true }}
                />
              )}
              onChange={(event: React.ChangeEvent<HTMLSelectElement>, option: IProductSelectOption) =>
                setSortBy(option.value as string)
              }
            />
          </>
        ) : (
          ''
        )}
      </div>

      {productOptions.sort(sortingFunction).map((result, index) => (
        <ResultItem key={index} resultItem={result} />
      ))}
    </div>
  );
};
